import { GET_CITY, GET_COMMISSION, GET_COUNTRY } from "../constants";

export const master = (state = { cityList: [], countrylist: {}, commissiondetails: {} }, action) => {
  switch (action.type) {
    case GET_CITY:
      return { ...state, cityList: action.cityList };
    case GET_COMMISSION:
      return { ...state, commissiondetails: action.commissiondetails };
    case GET_COUNTRY:
      return { ...state, countrylist: action.countrylist };
    default:
      return state;
  }
};
